"use strict";

import angular from "angular";

angular.module("nucont.shared", []);
